import React from 'react';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

const ErrorDialog = (props) => {
    const { open, noClick, title, details } = props;
    return (
        <div>
            <Dialog
                open={open}
                onClose={noClick}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
                <DialogContent>
                    {details.map((detail, idx) => (
                        <p key={idx}>{`${detail.code}: ${detail.description} in ${detail.field}`}</p>
                    ))}
                </DialogContent>
                <DialogActions>
                    <Button onClick={noClick} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default ErrorDialog;